export default __webpack_public_path__ + "static/media/application.3baeb4d4.svg";